import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/codebuild/output/src2613691020/src/next-app/app/_components/AppProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2613691020/src/next-app/app/_components/DndProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnglishIntlProvider"] */ "/codebuild/output/src2613691020/src/next-app/app/_components/EnglishIntlProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProdGoogleAnalytics"] */ "/codebuild/output/src2613691020/src/next-app/app/_components/ProdGoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Polyfill"] */ "/codebuild/output/src2613691020/src/next-app/app/polyfill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CSPostHogProvider"] */ "/codebuild/output/src2613691020/src/next-app/app/posthog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StitchesRegistry"] */ "/codebuild/output/src2613691020/src/next-app/src/pattern-library/basicUI/StitchesRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2613691020/src/node_modules/material-icons/iconfont/filled.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2613691020/src/node_modules/material-icons/iconfont/outlined.css");
